
import React, { Component } from "react";
import { useLocation } from "react-router-dom";
import { Navbar, Container, Nav, Dropdown, Button } from "react-bootstrap";
import UserProfile from "components/UserProfile/UserProfile";
import Settings from "components/Options/Settings";
import routes from "routes.js";
import { useHistory } from "react-router-dom";
import $ from 'jquery';
import { useEffect, useState } from "react";
import toast, { Toaster } from 'react-hot-toast';

function Header() {
  const location = useLocation();
  const history = useHistory();
  const mobileSidebarToggle = (e) => {
    e.preventDefault();
    document.documentElement.classList.toggle("nav-open");
    var node = document.createElement("div");
    node.id = "bodyClick";
    node.onclick = function () {
      this.parentElement.removeChild(this);
      document.documentElement.classList.toggle("nav-open");
    };
    document.body.appendChild(node);
  };

  const getBrandText = () => {
    for (let i = 0; i < routes.length; i++) {
      if (location.pathname.indexOf(routes[i].layout + routes[i].path) !== -1) {
        return routes[i].name;
      }
    }
    return "Brand";
  };

  const zoomOut = async () => {
    let zoom = await Settings.getZoom();
    if(zoom != null)
    {
      zoom = parseFloat(zoom);
    }
    else
    {
      zoom = $(".auto-zoom").css("zoom");
    }

    zoom = parseFloat(zoom);
    if(zoom > 0.1 && zoom < 1.5)
    {
      zoom = zoom - 0.1;
    }
    else
    {
      zoom = 0.2;
    }
    $(".auto-zoom").css("zoom",zoom);

    await Settings.setZoom(zoom);
    toast(
      parseInt(zoom*100)+"%",
      {
        duration: 2000,
      }
    );

  };

  const zoomIn = async () => {
    let zoom = await Settings.getZoom();
    if(zoom == null)
    {
      zoom = $(".auto-zoom").css("zoom");
    }

    zoom = parseFloat(zoom);
    if(zoom > 0.1 && zoom < 1.5)
    {
      zoom = zoom + 0.1;
    }
    else
    {
      zoom = 0.2;
    }
    $(".auto-zoom").css("zoom",zoom);
    await Settings.setZoom(zoom);
    toast(
      parseInt(zoom*100)+"%",
      {
        duration: 2000,
      }
    );
  };

  const toggleDarkMode = async () => {
    let dark = await Settings.getDark();
    if(dark == null)
    {
      dark = true;
    }
    else
    {
      if(dark == "true")
      {
        dark = false;
      }
      else
      {
        dark = true;
      }
    }

    await Settings.setDark(dark);
    window.location.reload(true);
  };

  const logout = async () =>
  {
    await localStorage.removeItem("user");
    window.location.href = '/login';
  }

  useEffect( async () => {
    let zoom = await Settings.getZoom();
    let dark = await Settings.getDark();
    $(".auto-zoom").css("zoom",zoom);

    if(dark == "true") {
      //require("../../assets/css/dark.css");
    }

  }, []);

  return (
    <Navbar bg="light" expand="lg">
     
      <Container fluid>
        <div className="d-flex justify-content-center align-items-center ml-2 ml-lg-0">
          <Button
            variant="dark"
            className="d-lg-none btn-fill d-flex justify-content-center align-items-center rounded-circle p-2"
            onClick={mobileSidebarToggle}
          >
            <i className="fas fa-ellipsis-v"></i>
          </Button>
          <Navbar.Brand
            href="#home"
            onClick={(e) => e.preventDefault()}
            className="mr-2"
          >
            {getBrandText()}
          </Navbar.Brand>
        </div>
        <Navbar.Toggle aria-controls="basic-navbar-nav" className="mr-2">
          <span className="navbar-toggler-bar burger-lines"></span>
          <span className="navbar-toggler-bar burger-lines"></span>
          <span className="navbar-toggler-bar burger-lines"></span>
        </Navbar.Toggle>
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="ml-auto" navbar>
            <Nav.Item>
              <Nav.Link
                className="m-0"
                href="#"
                onClick={() => zoomOut()}
              >
                <span className="fa fa-minus"></span>
              </Nav.Link>
              <Nav.Link
                className="m-0"
                href="#"
                onClick={() => zoomIn()}
              >
                <span className="fa fa-plus"></span>
              </Nav.Link>
              <Nav.Link
                className="m-0"
                href="#"
                onClick={() => toggleDarkMode()}
              >
                <span className="fa fa-moon"></span>
              </Nav.Link>
              <Nav.Link
                className="m-0"
                href="#"
                onClick={() => logout()}
              >
                <span className="no-icon">Log out</span>
              </Nav.Link>
              
            </Nav.Item>
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
}

export default Header;
